import { Dialog } from '@e3dc-react/shell/Elements/Dialog'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Typography } from '@mui/material'
import React from 'react'
import useShopSavedSystemConfiguration from '../../hooks/use-shop-saved-system-configuration'
import { useTypedSelector } from 'src/State/RootReducer'
import { useSnackbar } from '@e3dc-react/shell/Hooks/Snackbar'
import { SystemConfigureType } from '../../types'

export interface ShopUpdateSystemConfigurationProps {
  configuratorId: SystemConfigureType | string
  place: number
  onClose: () => void
}

/*
 * This component is a modal which ask if user wants to override the saved configurator or no.
 */
const ShopUpdateSystemConfigurationModal: React.FC<ShopUpdateSystemConfigurationProps> = ({ onClose, place, configuratorId }) => {
  const { t } = useCustomTranslation()

  const { enqueueSuccessStack, enqueueErrorStack } = useSnackbar()
  const { updateSystemConfiguration, isLoading } = useShopSavedSystemConfiguration()
  const configuratorItems = useTypedSelector(state => state.systemStorage.items)
  const configurator = configuratorItems.length > 0 ? configuratorItems[0] : null

  const modalActions = {
    primary: {
      name: t('common.save'),
      onClick: () => {
        configurator !== null &&
          updateSystemConfiguration(configuratorId, configurator)
            .then(() => {
              enqueueSuccessStack(t('shop.save-system-configure.updated-successfully'))
            })
            .catch(error => {
              console.error(error)
              enqueueErrorStack(t('shop.save-system-configure.update-failed'))
            })
        onClose()
      },
      isLoading: isLoading,
    },
    secondary: [
      {
        name: t('common.cancel'),
        onClick: () => onClose(),
      },
    ],
  }

  return (
    <Dialog title={t('shop.update-system-configure.title')} onClose={onClose} actions={modalActions} maxWidth="sm" place={place}>
      <Typography variant="h4">{t('shop.update-system-configure.update-message')}</Typography>
    </Dialog>
  )
}

export default ShopUpdateSystemConfigurationModal
